import React, {forwardRef} from "react";
import Slider, { Settings } from "react-slick";

export const TeaserSliderWrapper = forwardRef<Slider, Settings & {children: React.ReactNode}>(
  function TeaserSliderWrapper({children, ...settings}, ref) {
    return <Slider ref={ref} {...settings}>{children}</Slider>
  }
);

export function preloadTeaserSliderWrapper() {
  // no-op: react-slick is now included in the main bundle
}
